module.exports = __webpack_public_path__ + "static/Service-Academy-Group1-aca352b617d14827deaa4e41411584b2.png";